import { z } from 'zod';

import { nullishDefault } from '../../../utils/nullableDefault';
import { Anschrift } from '../Anschrift';

export const BeschaeftigungRentner = z.object({
    rentenversicherung: nullishDefault(
        z.object({
            anschrift: Anschrift.omit({ wohnhaftSeit: true }),
            name: nullishDefault(z.string()),
        }),
    ),
    rentnerSeit: nullishDefault(z.coerce.date()),
    staatlicheRenteMonatlich: nullishDefault(z.number()),
});

// rentner: yup
// .object()
// .shape({
// 	rentenversicherung: yup.object().shape({
// 		anschrift: yup.object().shape({
// 			hausnummer: yup.string().optional().nullable().default(null),
// 			land: yup
// 				.string()
// 					'AD',
// 				.oneOf([
// 					'AE',
// 					'AF',
// 					'AG',
// 					'AL',
// 					'AM',
// 					'AO',
// 					'AR',
// 					'AT',
// 					'AU',
// 					'AZ',
// 					'BA',
// 					'BB',
// 					'BD',
// 					'BE',
// 					'BF',
// 					'BG',
// 					'BH',
// 					'BI',
// 					'BJ',
// 					'BN',
// 					'BO',
// 					'BR',
// 					'BS',
// 					'BT',
// 					'BW',
// 					'BY',
// 					'BZ',
// 					'CA',
// 					'CD',
// 					'CF',
// 					'CG',
// 					'CH',
// 					'CI',
// 					'CK',
// 					'CL',
// 					'CM',
// 					'CN',
// 					'CO',
// 					'CR',
// 					'XK',
// 					'CU',
// 					'CV',
// 					'CY',
// 					'CZ',
// 					'DE',
// 					'DJ',
// 					'DK',
// 					'DM',
// 					'DO',
// 					'DZ',
// 					'EC',
// 					'EE',
// 					'EG',
// 					'ER',
// 					'ES',
// 					'ET',
// 					'FI',
// 					'FJ',
// 					'FM',
// 					'FR',
// 					'GA',
// 					'GB',
// 					'GD',
// 					'GE',
// 					'GH',
// 					'GM',
// 					'GN',
// 					'GQ',
// 					'GR',
// 					'GT',
// 					'GW',
// 					'GY',
// 					'HN',
// 					'HR',
// 					'HT',
// 					'HU',
// 					'ID',
// 					'IE',
// 					'IL',
// 					'IN',
// 					'IQ',
// 					'IR',
// 					'IS',
// 					'IT',
// 					'JM',
// 					'JO',
// 					'JP',
// 					'KE',
// 					'KG',
// 					'KH',
// 					'KI',
// 					'KM',
// 					'KN',
// 					'KP',
// 					'KR',
// 					'KW',
// 					'KZ',
// 					'LA',
// 					'LB',
// 					'LC',
// 					'LI',
// 					'LK',
// 					'LR',
// 					'LS',
// 					'LT',
// 					'LU',
// 					'LV',
// 					'LY',
// 					'MA',
// 					'MC',
// 					'MD',
// 					'ME',
// 					'MG',
// 					'MH',
// 					'MK',
// 					'ML',
// 					'MM',
// 					'MN',
// 					'MR',
// 					'MT',
// 					'MU',
// 					'MV',
// 					'MW',
// 					'MX',
// 					'MY',
// 					'MZ',
// 					'NA',
// 					'NE',
// 					'NG',
// 					'NI',
// 					'NL',
// 					'NO',
// 					'NP',
// 					'NR',
// 					'NU',
// 					'NZ',
// 					'OM',
// 					'PA',
// 					'PE',
// 					'PG',
// 					'PH',
// 					'PK',
// 					'PL',
// 					'PS',
// 					'PT',
// 					'PW',
// 					'PY',
// 					'QA',
// 					'RO',
// 					'RS',
// 					'RU',
// 					'RW',
// 					'SA',
// 					'SB',
// 					'SC',
// 					'SD',
// 					'SE',
// 					'SG',
// 					'SI',
// 					'SK',
// 					'SL',
// 					'SM',
// 					'SN',
// 					'SO',
// 					'SR',
// 					'SS',
// 					'ST',
// 					'SV',
// 					'SY',
// 					'SZ',
// 					'TD',
// 					'TG',
// 					'TH',
// 					'TJ',
// 					'TL',
// 					'TM',
// 					'TN',
// 					'TO',
// 					'TR',
// 					'TT',
// 					'TV',
// 					'TZ',
// 					'UA',
// 					'UG',
// 					'US',
// 					'UY',
// 					'UZ',
// 					'VA',
// 					'VC',
// 					'VE',
// 					'VN',
// 					'VU',
// 					'WS',
// 					'YE',
// 					'ZA',
// 					'ZM',
// 					'ZW',
// 					'SONSTIGE',
// 					null,
// 				])
// 				.optional()
// 				.nullable()
// 				.default(null),
// 			ort: yup.string().optional().nullable().default(null),
// 			plz: yup.string().optional().nullable().default(null),
// 			strasse: yup.string().optional().nullable().default(null),
// 		}),
// 		name: yup.string().optional().nullable().default(null),
// 	}),
// 	rentnerSeit: yup.date().optional().nullable().default(null),
// 	staatlicheRenteMonatlich: yup.number().optional().nullable().default(null),
// })
// .notRequired()
// .default(undefined)
// .when('beschaeftigungsart', {
// 	is: 'RENTNER',
// 	otherwise: (s) => s.strip(),
// 	then: (s) => s.optional().nullable().default(null),
// }),
